import Client from "./client";

// Whether this installation has a sandbox project set up, and where it is.
// No access token: the landing page needs this before anyone is signed in.
//
// Never rejects. Not having a sandbox configured is an ordinary state of an
// installation rather than an error, and the caller's job is to hide a
// button - so a failure and "none configured" are deliberately the same
// answer, same reasoning as GetHelpPortal.
export const GetSandboxStatus = () => {
    return new Promise((resolve) => {
        Client.get('/api/public/sandbox').then((res) => {
            resolve(res.data || {available: false, publicId: null, name: null});
        }).catch(() => {
            resolve({available: false, publicId: null, name: null});
        })
    })
}
